import apiService from "../../Services/APIService";
import { checkAPIResponse } from "../../Utils/APIResponseUtils";
import { toast } from 'sonner';

export const setExpensesDataAPI = async (expenseData, operation = 'ADD') => {
  try {
    const isDelete = operation === 'DEL';
    const exp = expenseData;

    const preparedExpenseData = {
      changeType: isDelete ? 'DEL' : operation,
      expenseID: exp.expenseID || 0,
      expenseDT: exp.expenseDT,
      amount: parseFloat(exp.amount) || 0,
      expenseTypeID: exp.expenseTypeID === 0 ? 1 : exp.expenseTypeID,
      expenseNotes: exp.notes || ''
    };

    const result = await apiService.sendChange(13, "set", [preparedExpenseData]); 
    checkAPIResponse(result);

    return {
      ...result,
      expenseID: exp.expenseID || 0,
      expenseData: {
        expenseID: exp.expenseID || 0,
        expenseDT: exp.expenseDT,
        amount: parseFloat(exp.amount),
        expenseTypeID: exp.expenseTypeID,
        notes: exp.notes || ''
      }
    };

  } catch (error) {
    console.error(`${operation} expense API error:`, error);
    throw error;
  }
};

export const getExpensesAPI = async ({ prdType, prdQty, year, month }) => {
  try {
    const payload = [{
        prdType,
        prdQty,
        year,
        month,
      }];
    const result = await apiService.getData(13, "get", payload);
    checkAPIResponse(result);
    const updatePackage = JSON.parse(result.updatePackage);
    const data = updatePackage.Table1;
    return data
  } catch (error) {
    console.error("ExpensesAPI Error:", error);
    toast.error(error?.message || 'Failed to load expenses.');
    throw error
  }
};

